import React from "react";
import ReactDOM from "react-dom";
import "./styles/globals.css";
import App from "./components/App/";
import { signIn } from "./utils/authn";
import apiProxy from "./api/apiProxy";
import { Observable, BehaviorSubject, combineLatest, forkJoin } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { setObservableConfig, componentFromStream } from "recompose";
import withLoadingAndErrorHandling from "./utils/reactive/wrapPageApiCall.js";
import ErrorView from "./components/ErrorView";
import { swallowApiErrors } from "./api/util";

setObservableConfig({
  fromESObservable: esObservable => {
    if (esObservable instanceof Observable) return esObservable;
    return new Observable(observer => {
      const subscription = esObservable.subscribe({
        next: v => observer.next(v),
        error: e => observer.error(e),
        complete: () => observer.complete()
      });
      return () => {
        if (subscription && typeof subscription.unsubscribe === 'function') {
          subscription.unsubscribe();
        }
      };
    });
  },
  toESObservable: observable => observable
});

const renderError = () => {
  ReactDOM.render(<ErrorView />, document.getElementById("root"));
};

const renderApp = () => {
  ReactDOM.render(
    <StreamedApp
      getLightingStores={apiProxy.storeLighting.getStores}
      getEnabledFeatures={apiProxy.configuration.getEnabledFeatures}
      getEnabledLightingFeatures={
        apiProxy.lightingConfiguration.getEnabledLightingFeatures
      }
      getUserRoles={apiProxy.userRoles.getUserRoles}
      getEnergyStores={apiProxy.store.getStores}
    />,
    document.getElementById("root")
  );
};

const StreamedApp = componentFromStream(props$ => {
  const fetchTrigger$ = new BehaviorSubject(null);

  const triggerFetch = () => {
    fetchTrigger$.next();
  };

  return withLoadingAndErrorHandling(() => {
    return combineLatest(props$, fetchTrigger$).pipe(
      mergeMap(([props]) => {
        return forkJoin(
          swallowApiErrors(props.getEnabledFeatures, { features: [] }),
          swallowApiErrors(props.getEnabledLightingFeatures, { features: [] }),
          swallowApiErrors(props.getUserRoles, { roles: [] }),
          swallowApiErrors(props.getLightingStores, { stores: [] }),
          swallowApiErrors(props.getEnergyStores, { stores: [] })
        );
      }),
      map(
        ([
          enabledFeatures,
          enabledLightingFeatures,
          userRoles,
          lightingStores,
          energyStores
        ]) => (
          <App
            enabledFeatures={enabledFeatures.features.concat(
              enabledLightingFeatures.features
            )}
            userRoles={userRoles.roles}
            stores={{
              energy: energyStores.stores,
              lighting: lightingStores.stores
            }}
            onLightingStoresChange={triggerFetch}
          />
        )
      )
    );
  });
});

signIn().then(
  ({ isSilentRefresh }) => {
    if (isSilentRefresh) {
      return;
    }
    renderApp();
  },
  (err) => {
    renderError();
  }
);
